import React from "react";
import Navbar from "../Navbar/Navbar";
import { useState, useEffect } from "react";
import { API } from "../../Redux/actions/API";
// import { ToastContainer, toast } from 'react-toastify';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function RequestTokenCancel() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [id, setId] = useState(searchParams.get("Id"));
  const [amount, setAmount] = useState(searchParams.get("amount"));
  const [remark, setRemark] = useState("");
  const [releasedAmount, setReleasedAmount] = useState("0");

  const Massage_API = async () => {
    try {
      let res = await API.post(`/updateRequestToken`, {
        id: id,
        releasedAmount: 0,
        status: 2,
        remark: remark,
      });

      console.log("res", res);
      if (res.data.data === "Successfull") {
        toast.success("Requested USDT Canceled SuccessFully");
        navigate(`/RequestToken`);
      } else {
        toast.error(res.data.data);
      }
    } catch (e) {
      console.log("Something Error in Massage API", e);
    }
  };

  //   const handleInputChange = (event) => {
  //     const newValue = event.target.value.replace(/[^a-z0-9 ]/gi, "");
  //     setRank(newValue);
  //   };

  //   const referral_API = async () => {
  //     try {
  //       let responceRight = await API?.get(`/helpDeskListById?id=${id}`);

  //       console.log("referral_API", responceRight?.data);
  //       responceRight = responceRight.data.data[0];
  //       setQuery(responceRight.query);
  //       setSub(responceRight.subject);
  //     } catch (e) {
  //       console.log("Error While calling Myteam API", e);
  //     }
  //   };

  //   useEffect(() => {
  //     referral_API();
  //   }, []);

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Cancel Requested USDT Form</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div class="box col-md-12">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-6 mr-30">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <h1 className="fw-bold">
                                  Cancel Requested USDT Form
                                </h1>
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                {/* <!---onclick number increase start--> */}
                                <div className="form-group">
                                  <label>Requested USDT</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Subject"
                                    value={amount}
                                    readOnly
                                  ></input>
                                </div>
                                <div className="form-group">
                                  <label>Cancel Remark</label>
                                  <textarea
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Write Remark.."
                                    onChange={(e) => setRemark(e.target.value)}
                                  />
                                </div>

                                {/* <div className="form-group">
                                  <label> Released Token</label>
                                  <input
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Released Token"
                                    onChange={(e) =>
                                      setReleasedAmount(e.target.value)
                                    }
                                  ></input>
                                </div> */}

                                <div class="joinbtn d-flex flex-row-reverse me-auto ">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={() => Massage_API()}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div class="col-md-6">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <h1 className="fw-bold">Image Table</h1>
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <!---onclick number increase start-->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
}

export default RequestTokenCancel;
